import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import YearSection from './YearSection';
import './TeamSection.css';

const TeamSection = ({ teamName, yearsData }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const years = Object.keys(yearsData).sort((a, b) => b - a);

  const handleTeamClick = (e) => {
    if (e.target.closest('.team-badge')) {
      e.stopPropagation();
      navigate(`/team/${encodeURIComponent(teamName)}`);
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="team-section">
      <div 
        className="team-header"
        onClick={handleTeamClick}
      >
        <div className="team-header-content">
          {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
          <h3 className="team-name">{teamName}</h3>
          <span className="team-badge">{years.length} Years</span>
        </div>
      </div>

      {isExpanded && (
        <div className="team-body">
          {years.map((year) => (
            <YearSection
              key={year}
              year={year}
              statsData={yearsData[year]}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamSection;
